// extracted by mini-css-extract-plugin
module.exports = {"image":"_2mUb8K","brand":"_8BR0-x","name":"w7UytQ","bottomNode":"_3Hh1fy","shine-lines":"_2RyWY_","content":"_2vWL3t","mainContent":"_3Abqpc"};